/**
 * Theme constants for application styling
 * Centralizes all theme variables to ensure consistency
 */
const THEME = {
  COLORS: {
    // Primary Colors
    PRIMARY_BLUE: 'var(--primary-blue)',
    PRIMARY_BLUE_DARK: 'var(--primary-blue-dark)',
    PRIMARY_BLUE_LIGHT: 'rgba(30, 82, 243, 0.05)', // Light blue for hover effects

    // Neutral Colors
    NEUTRAL_BLACK: 'var(--neutral-black)',
    NEUTRAL_WHITE: 'var(--neutral-white)',
    NEUTRAL_BLACK_LIGHT: 'var(--neutral-black-light)',
    NEUTRAL_BLACK_LIGHTER: 'var(--neutral-black-lighter)',
    NEUTRAL_WHITE_LIGHT: 'var(--neutral-white-light)',
    NEUTRAL_WHITE_LIGHTER: 'var(--neutral-white-lighter)',
    NEUTRAL_GRAY: 'var(--neutral-gray)',
    NEUTRAL_GRAY_LIGHT: 'var(--neutral-gray-light)',
    NEUTRAL_GRAY_DARK: 'var(--neutral-gray-dark)',
    NEUTRAL_LIGHT_GRAY: 'var(--neutral-light-gray)'
  },

  TYPOGRAPHY: {
    FONT_FAMILY: {
      PRIMARY: 'Manrope, sans-serif',
      SECONDARY: 'Nunito Sans, sans-serif'
    },
    FONT_SIZE: {
      XS: '0.75rem', // 12px
      SMALL: '0.875rem', // 14px
      MEDIUM: '1rem', // 16px
      LARGE: '1.25rem', // 20px
      XL: '1.5rem', // 24px
      XXL: '2rem', // 32px
      XXXL: '2.5rem' // 40px
    },
    FONT_WEIGHT: {
      LIGHT: 300,
      REGULAR: 400,
      MEDIUM: 500,
      SEMI_BOLD: 600,
      BOLD: 700,
      EXTRA_BOLD: 800
    },
    LINE_HEIGHT: {
      TIGHT: 1.2,
      NORMAL: 1.5,
      RELAXED: 1.75
    }
  },

  SPACING: {
    XS: '0.25rem', // 4px
    SMALL: '0.5rem', // 8px
    MEDIUM: '1rem', // 16px
    LARGE: '1.5rem', // 24px
    XL: '2rem', // 32px
    XXL: '3rem', // 48px
    XXXL: '4rem' // 64px
  },

  BORDERS: {
    RADIUS: {
      SMALL: '4px',
      MEDIUM: '8px',
      LARGE: '16px',
      ROUND: '50%'
    },
    WIDTH: {
      THIN: '1px',
      MEDIUM: '2px',
      THICK: '4px'
    }
  },

  SHADOWS: {
    SMALL: '0 2px 5px rgba(0, 0, 0, 0.1)',
    MEDIUM: '0 4px 10px rgba(0, 0, 0, 0.1)',
    LARGE: '0 8px 16px rgba(0, 0, 0, 0.1)',
    EXTRA_LARGE: '0 12px 24px rgba(0, 0, 0, 0.15)'
  },

  TRANSITIONS: {
    FAST: '0.2s',
    MEDIUM: '0.3s',
    SLOW: '0.5s'
  },

  BREAKPOINTS: {
    XS: 0, // 0px
    SM: 600, // 600px
    MD: 960, // 960px
    LG: 1280, // 1280px
    XL: 1920 // 1920px
  },

  Z_INDEX: {
    LOWEST: 0,
    LOW: 10,
    MEDIUM: 100,
    HIGH: 1000,
    HIGHEST: 9999
  }
};

// Helper functions for responsive design
THEME.up = breakpoint =>
  `@media (min-width: ${THEME.BREAKPOINTS[breakpoint]}px)`;
THEME.down = breakpoint =>
  `@media (max-width: ${THEME.BREAKPOINTS[breakpoint] - 0.05}px)`;
THEME.between = (start, end) =>
  `@media (min-width: ${THEME.BREAKPOINTS[start]}px) and (max-width: ${THEME.BREAKPOINTS[end] - 0.05}px)`;

export default THEME;
